/* USAGE 
Example: <IconButton type="green" icon={faArrowRight} />

Props:  
  "icon" - the FontAwesome icon - REQUIRED
  "iconType" - the FontAwesome icon type (far = regular pro | fab = free brands) - OPTIONAL - defaults to "far"
  "type" - The type of the button - REQUIRED at least one type: "green" or "white" or "blue" or "transparent" or "close" or "transparent-white"
  "className" - Allow additional classes to be passed to the component - OPTIONAL
  "onClick" - Function to be called when the button is clicked - OPTIONAL
*/

import { IconName, IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface Props {
  type:
    | "green"
    | "green-small"
    | "white"
    | "blue"
    | "transparent"
    | "close"
    | "close-small"
    | "transparent-white";
  icon: IconName | IconProp;
  iconType?: "far" | "fab";
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  buttonType?: "button" | "submit" | "reset" | undefined;
}

export const WIconButton = ({ iconType = "far", ...props }: Props) => {
  return (
    <button
      onClick={props.onClick}
      disabled={props.disabled}
      type={props?.buttonType}
      className={`flex-shrink-0 flex items-center justify-center flex-grow-0 ${
        props.type === "green"
          ? "icon-green-btn"
          : props.type === "green-small"
            ? "icon-green-small-btn"
            : props.type === "white"
              ? "icon-white-btn"
              : props.type === "blue"
                ? "icon-blue-btn"
                : props.type === "transparent"
                  ? "icon-transparent-btn"
                  : props.type === "close"
                    ? "close-btn"
                    : props.type === "close-small"
                      ? "close-btn-small"
                      : props.type === "transparent-white"
                        ? "icon-transparent-white"
                        : ""
      } ${props.className ? props.className : ""} ${
        props.disabled && "opacity-50"
      }`}
      aria-label={props?.icon?.toString()}
    >
      <FontAwesomeIcon icon={props?.icon} className="!w-4 !h-4" />
    </button>
  );
};

export default WIconButton;
